import qs from 'qs';

/** 获取链接参数 */
export const getUrlParams = () => {
    const _str = window.location.search.split('?')[1] || '';
    console.log(qs.parse(_str), 'getUrlParams');
    return qs.parse(_str);
};
// 浏览器信息解析方法
export const getSystemInfo = () => {
    const u = navigator.userAgent.toLowerCase();
    const qmVersionMatch = u.match(/webviewversion\/(\d+)/);
    const qmVersionMatch2 = u.match(/qmbrowser\/(\d+)/);
    const qmVersionMatchNew = u.match(/com\.yueyou\.cyreader\/(\d+)/);
    // 新版统一使用 com.yueyou.cyreader 判断， 旧版安卓webviewversion， ios qmbrowser
    // 旧版ios 在域名白名单内时会加上 webviewversion，但存在接口时机问题
    let appVersion = qmVersionMatchNew ? qmVersionMatchNew[1] : qmVersionMatch ? qmVersionMatch[1] : qmVersionMatch2 ? qmVersionMatch2[1] : '';
    const isIos = !!u.match(/mac os x/); // ios
    const isAndroid = u.indexOf('android') > -1 || u.indexOf('linux') > -1; // android
    const isHarmony = u.indexOf('openharmony') > -1; // 鸿蒙
    const isWeixin = u.indexOf('micromessenger') > -1; // 微信
    const isTrident = u.indexOf('trident') > -1; // IE内核
    const isQQ = !!u.match(/\sqq/i); // QQ
    const isWeibo = u.indexOf('weibo') > -1; // 微博

    let majorVersion = 0; // 系统主版本

    // 检查是否是iOS设备
    if (/iPad|iPhone|iPod/.test(u)) {
        const iOSMatch = u.match(/OS (\d+)_/);
        if (iOSMatch) {
            majorVersion = +iOSMatch[1];
        }
    }

    // 检查是否是Android设备
    if (/Android/.test(u)) {
        const androidMatch = u.match(/Android (\d+)/);
        if (androidMatch) {
            majorVersion = +androidMatch[1];
        }
    }
    if (import.meta.env.VITE_ENV === 'dev') {
        appVersion = '7777777';
    }
    return {
        appVersion: +appVersion || 0, // app 版本
        inQmApp: !!appVersion, // 是否在app内
        isTrident,
        isIos,
        isAndroid,
        isHarmony,
        platform: (isIos ? 'ios' : isHarmony ? 'harmonyos' : 'android') as 'ios' | 'android' | 'harmonyos',
        isWeixin,
        majorVersion,
        isQQ,
        isWeibo,
    };
};

/**
 * @description: 获取所处环境
 * @return {number}
 */
export const getAppEnv = () => {
    const regExp = /test\-env\/(\S*)/;
    if (navigator?.userAgent?.toLowerCase()?.match(regExp)) {
        return (navigator?.userAgent?.toLowerCase()?.match(regExp) as string[])[1];
    }
    return '';
};

// 非正式环境请求url需要加-test
export const changeEnvUrl = (str: string) => {
    // 例如 http://xiaoshuo.wtzw.com 会被格式化成 http://xiaoshuo-test.wtzw.com
    return str.replace(/http[s]?:\/\/[\s\S]+.com/, (regStr) => {
        const arr = regStr.split('.') || [];
        arr[0] = `${arr[0]}-test`;
        return arr.join('.');
    });
};

// 时间格式化
export function formatDate(dateTime: number, fmt = 'YYYY-MM-DD') {
    const date = new Date(dateTime);
    const o = {
        'Y+': date.getFullYear(), // 年份
        'M+': date.getMonth() + 1, // 月份
        'D+': date.getDate(), // 日
        'H+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
    };
    if (/(Y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, `${date.getFullYear()}`.substring(4 - RegExp.$1.length));
    }
    for (const k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : `00${o[k]}`.substring(`${o[k]}`.length));
        }
    }
    return fmt;
}

// storage 使用 jsbStorage

// --start sessionStorage
export function setSession(key: string, value: any) {
    let _val = value;
    if (typeof value === 'object') {
        _val = JSON.stringify(value);
    }
    sessionStorage.setItem(key, _val);
}
export function getSession(key: string) {
    const _value = sessionStorage.getItem(key);
    try {
        const _val = JSON.parse(_value!);
        if (typeof _val === 'object') {
            return _val;
        }
        return _value;
    } catch (e) {
        return _value;
    }
}
export function removeSession(key: string) {
    if (key) {
        sessionStorage.removeItem(key);
    } else {
        sessionStorage.clear();
    }
}
// --end

// 处理数字，兼容精度问题
export const formatNumber = (num: number, digits = 1) => {
    if (Number.isInteger(num)) {
        return num;
    }
    return parseFloat(num.toFixed(digits));
};

// 兼容requestIdleCallback
export const polyfillRequestIdleCallback = () => {
    if (!window.requestIdleCallback) {
        window.requestIdleCallback = function(cb) {
            const start = Date.now();
            return setTimeout(function() {
                cb({
                    didTimeout: false,
                    timeRemaining: function() {
                        return Math.max(0, 50 - (Date.now() - start));
                    },
                });
            }, 1);
        };
    }
};
